export default __webpack_public_path__ + "static/media/icon-filter-circle-outline.382cd670.svg";